import type { InventoryAdjustment } from '../types/inventoryAdjustment';

export const inventoryAdjustmentRowKey = (adj: InventoryAdjustment): string =>
  String(adj.id);

export const adjustmentTotalValue = (adj: InventoryAdjustment): number =>
  adj.lines.reduce((sum, line) => sum + line.value_change, 0);

export interface InventoryAdjustmentTotals {
  count: number;
  valueChange: number;
}

export const computeInventoryAdjustmentTotals = (
  rows: InventoryAdjustment[]
): InventoryAdjustmentTotals => {
  let valueChange = 0;
  for (const row of rows) {
    valueChange += adjustmentTotalValue(row);
  }
  return {
    count: rows.length,
    valueChange,
  };
};
